export const translations = {
  'fi-FI': {
    translation: {
      addUser: 'Lisää käyttäjä',
      editUser: 'Muokkaa käyttäjää',
      firstName: 'Etunimi',
      lastName: 'Sukunimi',
      name: 'Nimi',
      role: 'Rooli',
      status: 'Tila',
      email: 'Sähköposti',
      phone: 'Puhelin',
      type: 'Tyyppi',
      details: 'Yksityiskohdat',
      nodes: 'Solmut',
      roles: 'Roolit',
      cancel: 'Peruuta',
      submit: 'Lähetä',
      delete: 'Poista',
      create: 'Luo',
      deleteNodeError: 'Virhe solmun poistamisessa',
      deleteConfirmation: 'Haluatko varmasti poistaa?',
      warning: 'Varoitus',
      Alert: 'Hälytys',
      deleteSure: 'Kyllä, olen varma',
      nodesWillBeCreatedAt: 'Solmut luodaan kohteeseen',
      searchFor: 'Etsi',
      rolesError: 'Virhe roolien noutamisessa',
      userListError: 'Virhe käyttäjäluettelon noutamisessa',
      organisationListError: 'Virhe organisaatioluettelon noutamisessa',
      loadingRoles: 'Ladataan rooleja...',
      selectRole: 'Valitse rooli',
      validEmail: 'Anna kelvollinen sähköpostiosoite',
      requiredEmail: 'Sähköposti vaaditaan',
      resend: 'Lähetä uudelleen',
      restrictedDomain: 'Rajoitettu sähköpostitoimialue',
      addUserSuccess: 'Käyttäjä lisätty onnistuneesti',
      editUserSuccess: 'Käyttäjän muokkaaminen onnistui',
      deleteUserSuccess: 'Käyttäjän poisto onnistui',
      deleteModalAlertMessage:
        'Olet poistamassa käyttäjää {{userName}}. Kaikki käyttäjän käyttöoikeudet peruutetaan.',
      deleteProceedMessage: 'Haluatko jatkaa poistamista?',
      userAlreadyExist: 'Käyttäjä on jo olemassa tällä sähköpostitunnuksella.',
      addUserError: 'Käyttäjää ei voitu lisätä. Yritä uudelleen.',
      editUserError: 'Käyttäjää ei voitu muokata. Yritä uudelleen.',
      deleteUserError: 'Käyttäjää ei voitu poistaa. Yritä uudelleen.',
      nodesError: 'Virhe haettaessa määritettyjä solmuja',
      childNodesError: 'Virhe ladattaessa hierarkiatasoa',
      hierarchyError: 'Virhe hierarkian noutamisessa',
      requestFailed: 'Pyyntö epäonnistui',
      emailSentSuccess: 'Aktivointisähköposti lähetetty onnistuneesti!',
      activationEmailError: 'Aktivointisähköpostin lähettäminen epäonnistui.',
      activationEmailError1:
        'Aktivointisähköpostin lähettäminen epäonnistui. Yritä myöhemmin uudelleen.',
      allOrganisations: 'Kaikki organisaatiot',
      address: 'Osoite',
      hierarchyMetaError: 'Virhe haettaessa hierarkian tietoja',
      nodeMetaError: 'Virhe solmun tietoja ladattaessa',
      contactName: 'Yhteyshenkilön nimi',
      downloadTemplate: 'Lataa malli',
      newOrg: 'Uusi organisaatio',
      save: 'tallenna',
      upload: 'lataa',
      uploading: 'Lataaminen',
      dropExcel: 'Pudota Excel-taulukko tai',
      browse: 'selaa',
      importSettings: 'Tuo asetukset',
      addNodesSites: 'Lisää uusia solmuja/toimipaikkoja',
      updateNodesSites:
        'Päivitä olemassa olevien solmujen/toimipaikkojen tiedot',
      disableNodesSites:
        'Poista käytöstä solmut/toimipaikat, joita ei enää ole',
      disabled: 'Ei käytössä',
      new: 'Uusi',
      updated: 'Päivitetty',
      siteInstallation: 'Toimipaikat',
      addOrgSuccess: 'Organisaation luonti onnistui!',
      excelUploadError:
        'Excel-tiedoston tallentaminen epäonnistui. Yritä uudelleen.',
      saveError: 'Tallentaminen epäonnistui. Yritä myöhemmin uudelleen.',
      saveBadRequestError:
        'Tallentaminen epäonnistui. Kyseessä on todennäköisesti ongelma tiedoissa, joita yritit tallentaa.',
      telephone: 'Puhelin',
      externalIds: 'Ulkoiset tunnukset',
      contactEmail: 'Yhteyshenkilön sähköpostiosoite',
      longitude: 'Pituusaste',
      latitude: 'Leveysaste',
      primaryContactName: 'Ensisijainen yhteyshenkilön nimi',
      primaryContactEmail: 'Ensisijainen sähköpostiosoite',
      templateError: 'Virhe mallin lataamisessa. Yritä myöhemmin uudelleen.',
      templateError1: 'Mallia ei saatu. Yritä myöhemmin uudelleen.',
      home: 'Koti',
      organisations: 'Organisaatiot',
      users: 'Käyttäjät',
      lightTheme: 'Vaalea teema',
      darkTheme: 'Tumma teema',
      login: 'Kirjaudu sisään',
      logout: 'Kirjaudu ulos',
      activateUserAcc: 'Aktivoi käyttäjätili',
      phoneNumber: 'Puhelinnumero',
      optional: 'valinnainen',
      password: 'Salasana',
      confirmPassword: 'Vahvista salasana',
      endUser: 'Loppukäyttäjän lisenssisopimus',
      iAccept: 'Hyväksyn loppukäyttäjän lisenssisopimuksen.',
      iHereby: 'Vahvistan, että olen lukenut ja hyväksynyt',
      eula: 'Käyttöoikeus',
      iRead: 'Olen lukenut Honeywellin tietosuojakäytännön',
      iUnderstood: 'Kyllä, olen lukenut ja ymmärtänyt',
      privacyPolicy: 'Tietosuojakäytäntö',
      activate: 'aktivoida',
      activationSuccess: 'Aktivointi onnistui',
      newAccAccess:
        'Kirjaudu sisään uudella käyttäjätunnuksellasi, jotta pääset uudelle tilillesi. Tämä uusi käyttäjätunnus näkyy alla:',
      emailSent: 'Uusi käyttäjätunnus on lähetetty sähköpostiosoitteeseesi.',
      signin: 'KIRJAUDU SISÄÄN',
      activationError: 'Aktivointi epäonnistui',
      pleaseTryAgain: 'Yritä uudelleen',
      activationExpired: 'Aktivointitunnus on vanhentunut',
      activationExpiredText:
        'Tämä voi johtua siitä, että sähköpostilinkki on vanhentunut, sitä on jo käytetty tai se oli virheellinen. Jos ongelma ei poistu, pyydä uusi aktivointisähköposti.',
      contactSupport: 'Virhe. Ota yhteyttä tukeen',
      pwdMatch: 'Salasanojen on vastattava toisiaan',
      required: 'Pakollinen',
      eligiblePwd:
        'Salasanassa on oltava vähintään 1 iso kirjain, 1 pieni kirjain, 1 numeromerkki, 1 erikoismerkki ja yhteensä vähintään 11 merkkiä',
      invalidPhoneNumber: 'Puhelinnumero virheellinen',
      invalidName:
        'Nimen pituus saa olla enintään 255 merkkiä ilman alku- tai loppuvälilyöntejä',
      invalidFirstName: 'Etunimi sisältää virheellisiä merkkejä.',
      invalidLastName: 'Sukunimi sisältää virheellisiä merkkejä.',
      timezone: 'aikavyöhyke',
      timeZone: 'Aikavyöhyke',
      commissioningStatus: 'Käyttöönoton tila',
      countryCode: 'Maakoodi',
      childCount: 'Alikohteiden määrä',
      sheetVersion: 'Arkin versio',
      unknownError: 'Tuntematon virhe. Yritä myöhemmin uudelleen.',
      preview: 'Esikatsele',
      file: 'Tiedosto',
      inCompatibleExcel: 'Tiedoston on oltava .xlsx-muodossa.',
      selectOrg: 'Valitse organisaatio',
      noRecordFound: 'Tietueita ei löytynyt',
      total: 'Yhteensä',
      items: 'Kohteet',
      forbidden: 'Kielletty',
      noPermissionText: 'Sinulla ei ole oikeutta käyttää tätä sivua',
      accessPermission: 'Kirjaudu sisään tilille, jolla on käyttöoikeudet',
      technicianExternalAccessPermission: 'Kirjaudu mobiilisovellukseen.',
      redirectToLogin: 'Uudelleenohjaus kirjautumissivulle',
      errorUserSettings: 'Virhe haettaessa käyttäjäasetuksia',
      invalidSystemGuid: 'Virheellinen järjestelmän GUID',
      languageNotSupported: 'Kieltä ei tueta',
      subscriptions: 'Tilaukset',
      gatewayManagement: 'Yhdyskäytävän hallinta',
      subscriptionNumber: 'Tilausnumero',
      orderNumber: 'Tilausnumero',
      bundle: 'Nippu',
      activatedOn: 'aktivointipäivä',
      order: 'järjestys',
      editSubscription: 'Muokkaa tilausta',
      noNodeSelected: 'Ei solmua valittu',
      noUserSelected: 'Käyttäjää ei valittu',
      loadingBundles: 'Ladataan nippuja...',
      bundlesError: 'Virhe nippujen noutamisessa',
      selectBundle: 'Valitse paketti',
      addSubscriptionSuccess: 'Tilauksen lisääminen onnistui',
      addSubscriptionError: 'Tilausta ei voitu lisätä. Yritä uudelleen.',
      subscriptionInputValidationError:
        'voi olla aakkosnumeerinen arvo yhdysmerkillä ja enintään 13 merkkiä',
      errorUserGlobalPrivileges:
        'Virhe noudettaessa käyttäjän globaaleja oikeuksia',
      subscriptionAlreadyExist: 'Tilaus on jo olemassa.',
      invalidSubscription: 'Virheellinen tilaus',
      Version: 'Versio',
      systemType: 'Järjestelmän tyyppi',
      systemId: 'Järjestelmän tunnus',
      reviewGatewayDetails: 'Tarkista yhdyskäytävän tiedot',
      site: 'Toimipaikka',
      Organisation: 'Organisaatio',
      gatewayRegistration: 'Yhdyskäytävän rekisteröinti',
      selectAnOrg: 'Valitse organisaatio',
      selectASite: 'Valitse sivusto',
      register: 'Rekisteröidy',
      selectSiteToRegsiter:
        'Valitse toimipaikka yhdyskäytävän rekisteröimiseksi',
      gatewayRegistrationFailureMsg:
        'Yhdyskäytävän rekisteröinti Honeywell Sentience IOT -alustalle epäonnistui',
      gatewayRegistrationSuccessMsg:
        'Gateway on rekisteröity onnistuneesti Honeywell Sentience IOT -alustalle',
      siteEmptyMsg:
        'Kaikki organisaation {{- orgName}} toimipaikat on jo rekisteröity',
      forgeOnboarding: 'Organisaation yhdistäminen',
      SiteFetchingFailure: 'Toimpaikkojen hakeminen Forgesta epäonnistui',
      selectAllSitesText:
        'Valitse kaikki Forge-toimipaikat, jotka haluat ottaa käyttöön Remote Building Managerissa',
      onBoardingFailure: 'Toimipaikan käyttöönoton aloittaminen epäonnistui',
      customerID: 'Asiakkaan tunnus',
      enterCustomerID: 'Syötä asiakastunnus',
      loadingSites: 'Ladataan toimipaikkoja...',
      fetchSites: 'HAE TOIMIPAIKKOJA',
      subscriptionActivateSuccess:
        'Tilaus "{{siteName}}" on aktivoitu onnistuneesti',
      subscriptionActivateError:
        'Ei voi aktivoida teknisen ongelman vuoksi, ota yhteyttä järjestelmänvalvojaan',
      activateNow: 'Aktivoi nyt',
      multiSiteSuccess: 'Toimipaikat lisättiin onnistuneesti.',
      onboardSelected: 'Ota käyttöön valitut',
      sitePartialSuccess:
        'Joidenkin toimipaikkojen käyttöönotto epäonnistui teknisen ongelman vuoksi. Yritä uudelleen tai ota yhteyttä järjestelmänvalvojaan.',
      confirm: 'Vahvista',
      onboardingFailed: 'Käyttöönotto epäonnistui',
      failed: 'epäonnistui',
      onboardedSuccessfully: 'Toimipaikka on otettu käyttöön',
      notOnboarded: 'Ei otettu käyttöön',
      onboarding: 'Otetaan käyttöön...',
      reOnboard: 'Uudelleenkäyttöönotto',
      selectAll: 'Valitse kaikki',
      siteSuccess: 'Toimipaikka lisätty onnistuneesti.',
      dataloseWarning: 'Älä päivitä sivua toimipaikkojen käyttöönoton aikana.',
      addServiceSuccess: 'Palvelut lisätty onnistuneesti',
      addServicesText: 'Lisää palveluita',
      validityText: 'Voimassaoloaika',
      invalidInputError: 'Virheellinen syöte',
      subsactivateError: 'Tilaus on jo aktivoitu',
      subsnotfoundError: 'Tilaustietoja ei löydy',
      invalidorderError: 'Virheellinen tilausnumero',
      bundnotfoundError: 'Nipun tietoja ei löydy',
      subscribedServices: 'TILATUT PALVELUT',
      subsactivateSuccess: 'Tilaus luotu ja aktivoitu onnistuneesti',
      subsactivateFailure:
        'Tilaus luotiin, mutta aktivointi epäonnistui. Yritä uudelleen.',
      subsactivateDiffSite: 'Tilaus on jo aktivoitu toiselle toimipaikalle',
      gatewayAssociation: 'Yhdyskäytävän liitos',
      systemGuid: 'Järjestelmän GUID',
      success: 'Onnistui',
      contactSystemAdministrator: 'Ota yhteyttä järjestelmänvalvojaan',
      siteName: 'Toimipaikan nimi',
      location: 'Sijainti',
      action: 'Toiminto',
      addNewSite: 'Lisää uusi toimipaikka',
      add: 'Lisää',
      sitesAssociated: '{{siteCount}} toimipaikkaa liitetty',
      numberOfAddon: 'Lisäosien määrä',
      searchSite: 'Etsi sivustoja',
      noResultFound: 'Tuloksia ei löytynyt',
      noDataFound: 'Tietoja ei löytynyt',
      loadMore: 'Lataa lisää',
      unlinkMessage:
        'Jos haluat irrottaa {{siteName}}:n {{sku}}:sta, ota yhteyttä Honeywellin asiakaspalvelukeskukseen (+01 480-353-3020) tai lähetä sähköpostia support@honeywell.com',
      associatedOrderNumber: 'Liittyvä tilausnumero',
      associatedSubscriptionNumber: 'Liittyvä tilausnumero',
      helperTextSKU: 'Jos haluat muuttaa tilausnumeroa, ota yhteyttä:',
      helperOrderTextSKU: 'Jos haluat muuttaa tilausnumeroa, ota yhteyttä',
      customerCare: 'Asiakaspalvelu',
      skuDetails: 'SKU-tiedot',
      manageSites: 'Hallitse toimipaikkoja',
      skuName: 'SKU:n nimi',
      skuDescription: 'SKU:n kuvaus',
      licenseUtilization: 'Lisenssin käyttö',
      validTill: 'Voimassa asti',
      editSKU: 'Muokkaa SKU:ta',
      duplicateSiteError: 'Toimipaikka on jo lisätty',
      numberOfAddonRequired: 'Syötä lisäosien määrä',
      siteFetchError: 'Virhe haettaessa toimipaikkaluetteloa',
      siteSuccessMsg: 'Toimipaikat lisätty onnistuneesti',
      siteFailedMsg: 'Toimipaikkojen lisääminen epäonnistui',
      problemWithRequest: 'Pyynnössä oli ongelma.',
      newSubscriptionAdded: 'Uusi tilaus lisätty',
      licensesOf: 'Lisenssit:',
      all: 'Kaikki',
      orderPlacedBy: 'Tilauksen tehnyt',
      pendingRenewal: 'Odottaa uusimista',
      daysRemaining: 'Jäljellä olevat päivät',
      renewSubscriptionMessage:
        'Jos haluat uusia {{skuName}}, ota yhteyttä Honeywellin asiakaspalvelukeskukseen (+01 480-353-3020) tai lähetä sähköpostia support@honeywell.com',
      columnSelection: 'Sarakkeen valinta',
      selectUpTo: 'Voit valita enintään',
      itemsToDisplay: 'kohdetta näytettäväksi taulukossa.',
      subscriptionManagement: 'Tilausten hallinta',
      activated: 'Aktivoitu',
      warningHeader: 'Oletko varma, että haluat peruuttaa?',
      warningMessage: 'Muutoksia on tallentamatta, ja ne voidaan menettää',
      renewSubscription: 'Uusi Tilaus',
      pendingActivation: 'Odottaa aktivointia',
      notAuthorizedError:
        'Sinulla ei ole valtuuksia määrittää SKU:ta tälle organisaatiolle',
      gatewayRegistrationInProgress: '{{gateway}} Käynnissä',
      gatewayAssociationFailed:
        'Tarkista yhdyskäytävän yhteys ja yritä uudelleen. Jos se epäonnistuu uudelleen, ota yhteyttä järjestelmänvalvojaan.',
      gatewayRegistrationFailed:
        'Yritä uudelleen. Jos toiminto epäonnistuu uudelleen, ota yhteyttä järjestelmänvalvojaan.',
      doAssociationMessage:
        'Tarkista yhdyskäytävän yhteys ja jatka yhdyskäytävän liittämistä.',
      errorInAssociation: 'Virhe liitoksen käsittelyssä.',
      association: 'Liittäminen',
      dataloseWarningForRegistration:
        'Yhdyskäytävän rekisteröinti on meneillään. Tämä voi kestää muutaman minuutin. Älä päivitä sillä välin, jotta tietoja ei häviä.',
      dataloseWarningForAssociation:
        'Yhdyskäytävän liittäminen on meneillään. Tämä voi kestää muutaman minuutin. Älä päivitä sillä välin, jotta tietoja ei häviä.',
      objectName: 'Kohteen nimi',
      objectType: 'Objektin tyyppi',
      unitName: 'Yksikkö',
      bitunpack: 'Bittien pakkauksen purku',
      bitRange: 'Bittialue',
      propName: 'Ominaisuuden nimi',
      propDataType: 'Tietotyyppi',
      propValue: 'Ominaisuuden arvo',
      msgType: 'VIESTIN TYYPPI',
      isMultiState: 'On monitilainen',
      scalingOperation: 'Skaalaustoiminto',
      scalingFactor: 'Skaalauskerroin',
      byteOrder: 'Tavujen järjestys',
      propertyName: 'Ominaisuuden nimi',
      addTemplateSuccess: 'Mallin lisääminen onnistui',
      addTemplateError: 'Mallinetta ei voitu lisätä. Yritä uudelleen.',
      updateTemplateSuccess: 'Mallin päivittäminen onnistui',
      updateTemplateError: 'Mallia ei voitu päivittää. Yritä uudelleen.',
      outOfRangeError: 'Arvon on oltava välillä {{min}} ja {{max}}',
      requiredField: 'Täytä kaikki kentät',
      templateName: 'Mallin nimi',
      modelName: 'Mallin nimi',
      vendorName: 'Toimittajan nimi',
      uniqueValueError: 'Arvon on oltava ainutlaatuinen',
      templateMangement: 'Mallien hallinta',
      equipmentType: 'Laitetyyppi',
      selectType: 'Valitse tyyppi',
      listOfTemplate: 'Luettelo malleista',
      selectTemplate: 'Valitse malli',
      ElectricityVoltage: 'Sähköjännite',
      ElectricityCurrent: 'Sähkövirta',
      ElectricPowerFactor: 'Sähkötehokerroin',
      ElectricFrequency: 'Sähkötaajuus',
      EnergyReceived: 'Vastaanotettu energia',
      ActivePower: 'Aktiiviteho',
      ActivePowerA: 'Aktiivinen teho A',
      ActivePowerB: 'Aktiivinen teho B',
      ActivePowerC: 'Aktiivinen teho C',
      ReactivePower: 'Loisteho',
      ApparentPower: 'Näennäinen teho',
      PeakDemand: 'Huippukysyntä',
      ElectricityCurrentA: 'Sähkövirta A',
      ElectricityCurrentB: 'Sähkövirta B',
      ElectricityCurrentC: 'Sähkövirta C',
      ElectricityVoltageA: 'Sähköjännite A',
      ElectricityVoltageB: 'Sähköjännite B',
      ElectricityVoltageC: 'Sähköjännite C',
      ElectricityConsumption: 'Sähkönkulutus',
      loaderWelcomeMessage: 'Tervetuloa käyttöönottoportaaliin. Odota hetki.',
      latitudeAndLongitude: 'Leveys- ja pituusasteet',
      siteUpdateSuccessMessage: 'Toimipaikan tiedot päivitetty onnistuneesti',
      siteUpdateErrorMessage: 'Virhe päivitettäessä toimipaikan tietoja',
      provisioningFailedMessages:
        'Toimipaikan valmistelu epäonnistui. Yritä uudelleen',
      onboardAllSites: 'Ota käyttöön kaikki toimipaikat',
      geoCordinatesErrorMsg: 'Tarkista koordinaatit',
      tooltipCordinateMessage: 'koordinaattien on oltava välillä',
      emptyValueMessage: 'Tyhjä arvo ei sallittu',

      browseFile: 'Selaa tiedostoa',
      fileTypeErrorMsg: 'Tiedostotyyppi ei ole sallittu',

      orgImgTitle: 'Lähetä organisaation logo',
      orgImgDropTxt: 'Vedä ja pudota logo',
      orgImgInfoTxt:
        'L {{width}}px X K {{height}}px ja vain *.png tiedostomuoto',
      orgImgPreviewTxt: 'Esikatsele logoa',
      orgImgTooltipTxt:
        'Logolla on oltava läpinäkyvä tausta, ja sen on erotuttava mustasta otsikon taustasta',
      orgImgSizeOfErrorMsg:
        'Kuvan koon tulee olla enimmäisleveys {{width}} pikseliä, enimmäiskorkeus {{height}} pikseliä, vähimmäisleveys {{minWidth}} pikseliä, vähimmäiskorkeus {{minHeight}} pikseliä ja enimmäistiedostokoko {{maxSize}} kt',

      siteImgTitle: 'Lataa toimipaikan kuva',
      siteImgDropTxt: 'Vedä ja pudota rakennuksen kuva (*.png tai .jpg)',
      siteImgPreviewTxt: 'Toimipaikan tietojen esikatselusivu',
      siteTooltipTxt:
        'Kuva rajataan 46 pikseliä oikealta ja vasemmalta sekä 30 pikseliä kuvan ylä- ja alareunasta näytön resoluution perusteella',
      siteImgInfoTxt:
        'L {{width}}px X K {{height}}px ja *.png & *.jpg tiedostomuoto',
      siteImgSizeOfErrorMsg:
        'Kuvan koon on oltava enimmäisleveys {{width}} pikseliä, korkeus {{height}} pikseliä ja enimmäistiedostokoko {{maxSize}} kt',
      orTxt: 'Tai',
      addLogo: 'Lisää logo',
      addImage: 'Lisää kuva',
      imageUploadSuccess: 'Kuva ladattu onnistuneesti',
      alertnteId: 'Vaihtoehtoinen käyttäjätunnus: ',
      username: 'Käyttäjätunnus: ',
      errorFetchingUser: 'Virhe käyttäjätietojen noutamisessa',
      errorFetchingRoles: 'Virhe roolien noutamisessa',

      gateway: 'YHDYSKÄYTÄVÄ',
      associateAndSyncBtn: 'LIITÄ JA SYNKRONOI',
      cancelBtn: 'PERUUTA',
      guidValidationError: 'GUID-vahvistusvirhe',
      gatewayId: 'YHDYSKÄYTÄVÄN TUNNUS',
      addNewGateway: 'Lisää uusi yhdyskäytävä',
      successMessage1: 'Toimipaikan liittäminen valmis',
      successMessage2:
        'Toimipaikan liittäminen valmis. Mallin synkronointi aloitetaan',
      errorMessage:
        'Yhdistäminen epäonnistui, mallin synkronointia ei aloiteta',
      importUsers: 'Tuo käyttäjiä',
      importUsersSubHeading:
        'Hallitse tuontia lataamalla ja lisäämällä CSV-malli.',
      dropCsvHere: 'Vedä ja pudota tiedosto tähän tai',
      browsrForFiles: 'Selaa tiedostoja',
      subHeadingBrowser:
        'Hyväksytään vain CSV-tiedosto, ja tiedostokoko ei saa ylittää 5 Mt.',
      subHeadingBrowserTwo: '(vain yksi lataus kerrallaan)',
      userUploadSuccess: 'Tietojen lähettäminen onnistui',
      userUploadProcessing:
        'Tiedot on ladattu onnistuneesti. Tietoja käsitellään parhaillaan, mikä kestää muutaman minuutin. Saat lisätietoa pian.',
      fileNameDisplay: 'Tiedoston nimi : ',
      fileName: 'Tiedoston nimi',
      errorNotification:
        'Mallia ladattaessa ilmeni ongelma. Korjaa alla ilmoitetut virheet ja lataa malli uudelleen.',
      errorHeading: 'Virhe',
      slnumber: 'SL-NRO',
      errorMessageHeading: 'VIRHEILMOITUS',
      endUserAgreement: 'Honeywell Forge -ehdot',
      privacyStatement: 'Tietosuojaseloste',
      yourPrivacyChoices: 'Tietosuojavalintasi',
      cookieNotice: 'Evästeilmoitus',
      dataCentre: 'Datakeskus',
      isForgeText: 'Rakennukset',
      gatewayIdleMessage:
        'Istuntosi on ollut joutotilassa muutaman minuutin – päivitä sivu jatkaaksesi',
      refresh: 'Päivitä',
      landingLogin: 'Klikkaa tästä',
      loginUserIntegratorRole: 'BA-verkkokaupan käyttäjät',
      loginUserCustomerRole: 'Kaikki muut käyttäjät',
      loginWelcomeNote: 'Tervetuloa – valitse roolisi alta aloittaaksesi.',
      termsAndConditions: 'Käyttöehdot',
      accept: 'Hyväksy',
      legalPatentInformation: 'Juridiset patenttitiedot',
      onboardingPortal: 'Käyttöönottoportaali',
      customers: 'Asiakkaat',
      templates: 'Mallit',
      assetModelling: 'Omaisuuden mallinnus',
      selectCustomer: 'Valitse asiakas',
      integration: 'Integrointi',
      integrationSubtitle:
        'Integroi saumattomasti reaaliaikaisia suorituskykytietoja varten',
      customer: 'Asiakas',
      accessibleCustomersError: 'Virhe saavutettavien asiakkaiden hakemisessa',
      workflows: 'Työnkulut (vanha)',
      apiCredentials: 'API-tunnukset',
      integrationsTab: 'Työnkulut',
      noSubscription:
        'Aktiivista tilausta ei löytynyt. Tee tilaus, jotta voit käyttää tätä ominaisuutta.',
      loading: 'Ladataan...',
      licenseManagement: 'Lisenssien hallinta',
      activityLogTitle: 'Toimintalokit',
      activityLogSubtitle:
        'Seuraa työnkulun tapahtumia ja tilapäivityksiä valittujen asiakkaiden kohdalla',
      activityLogSidebarTitle: 'Toimintalokit',
      activityLogSidebarSubtitle:
        'Tässä ovat kaikkien asiakasorganisaatioidesi toimintatiedot',
      activityLogListTitle: 'Toimintojen luettelo',
      activityLogSearchPlaceholder: 'Hae toiminnan tai sivuston mukaan',
      activityLogLastUpdated: 'Päivitetty viimeksi',
      activityLogCreatedOn: 'Luotu',
      activityLogActivity: 'Aktiviteetti',
      activityLogSite: 'Toimipaikka',
      activityLogStatus: 'Tila',
      activityLogCreatedBy: 'Luonut',
      activityLogUpdatedBy: 'Päivittänyt',
      activityLogNameUnavailable: 'Nimi ei ole saatavilla',
      activityLogUserNamesError:
        'CreatedBy/UpdatedBy-nimien lataaminen epäonnistui',
      activityLogStatusSuccess: 'Onnistui',
      activityLogStatusFailed: 'Epäonnistui',
      activityLogStatusInProgress: 'Käynnissä',
      activityLogStatusQueued: 'Jonossa',
      activityLogStatusPending: 'Odottaa',
      activityLogStatusSkipped: 'Ohitettu',
      activityLogPaginationInfo: 'Kohteet {startItem}–{endItem}/{totalItems}',
      activityLogPageGoTo: 'Siirry sivulle',
      activityLogRowPerPage: 'Riviä sivulla',
      activityLogRetry: 'Yritä uudelleen',
      activityLogRetrying: 'Yritetään uudelleen...',
      activityLogRetrySuccess:
        'Tehtävän uudelleenyritys aloitettiin onnistuneesti.',
      activityLogRetryError:
        'Tehtävän uudelleenyritys epäonnistui. Yritä uudelleen.',
      activityLogRetryAllSuccess: 'Kaikkien tehtävien uusintayritys onnistui.',
      activityLogRetryAllFailed:
        'Kaikki uusintayritykset epäonnistuivat. Ole hyvä ja yritä uudelleen.',
      activityLogRetryPartialFailed:
        'Joidenkin tehtävien uudelleenyritys epäonnistui. Yritä uudelleen.',
      activityLogLoading: 'Ladataan tietoja...',
      activityLogFetchError:
        'Aktiviteettitietojen lataaminen epäonnistui. Yritä uudelleen.',
      activityLogModalClose: 'Sulje',
      activityLogModalTasks: 'Tehtävät',
      activityLogModalCreatedOn: 'Luotu',
      activityLogModalLastUpdatedOn: 'Viimeksi päivitetty',
      activityLogModalSupportNote: 'Kuvaus vikatapahtumasta ja syykoodista.',
      activityLogModalSupportReach: 'Jos tarvitset apua, ota yhteyttä:',
      activityLogModalSupportEmail: 'connectedbuildingsupport@honeywell.com',
      activityLogFilterTitle: 'Suodatuskriteeri',
      noCustomersAvailable: 'Asiakkaita ei ole saatavilla',
      activityLogFilterStatus: 'Tila',
      activityLogFilterActivity: 'Aktiviteetti',
      activityLogFilterSite: 'Toimipaikka',
      activityLogFilterCreatedBy: 'Luonut',
      activityLogFilterApply: 'Käytä',
      activityLogFilterReset: 'Nollaa',
      activityLogFilterNoOptions: 'Vaihtoehtoja ei ole saatavilla',
      activityLogFilterError:
        'Suodatusvaihtoehtojen lataaminen epäonnistui. Yritä uudelleen.',
      search: 'Hae',
      more: 'enemmän',
      noResults: 'Tuloksia ei löytynyt',
      activityLogCustomizeColumns: 'Muokkaa sarakkeita',
      activityLogColumnsReorder: 'Järjestä uudelleen',
      activityLogColumnsAddRemove: 'Lisää/poista',
      activityLogColumnsReorderDescription:
        'Sijoita uudelleen muuttaaksesi sarakkeiden järjestystä taulukossa',
      activityLogColumnsAddRemoveDescription:
        'Valitse taulukossa näytettävät sarakkeet',
      activityLogDetails: 'Yksityiskohdat',
      activityLogFiltersChanged:
        'Valituilla suodattimilla ei löydy tietoja. Muuta hakua tai nollaa suodattimet saadaksesi tuloksia.',
      activityLogResetFilters: 'Nollaa suodattimet',
      activityLogSiteState: 'Tila',
      activityLogSiteCity: 'Kaupunki',
      workflowTaskCBCustomerCreation: 'CB-asiakkaan luominen',
      workflowTaskOnboardingStatusUpdatePartnerPortal:
        'Käyttöönoton tilan päivitys kumppaniportaalissa',
      workflowTaskUpdateCBCustomerIdPartnerPortal:
        'Päivitä CB-asiakastunnus kumppaniportaalissa',
      workflowTaskEOMCustomerCreation: 'EOM-asiakkaan luominen',
      workflowTaskOnboardCustomerForAI: 'Ota asiakas käyttöön tekoälyä varten',
      workflowTaskDeleteCustomerInCBPortal: 'Poista asiakas CB-portaalissa',
      workflowTaskUpdateCustomerInCBPortal: 'Päivitä asiakas CB-portaalissa',
      workflowTaskUpdateCustomerInEOM: 'Päivitä asiakas EOM:ssa',
      workflowTaskUpdateCustomerInAssetModelling:
        'Päivitä asiakas omaisuusmallinnuksessa',
      workflowTaskTrackScanStatusFileAttachment:
        'Seuraa tiedostoliitteen skannaustilaa',
      workflowTaskCBSiteCreation: 'CB-kohteen luominen',
      workflowTaskUpdateCBSiteIdPartnerPortal:
        'Päivitä CB-sivuston tunniste kumppaniportaalissa',
      workflowTaskEOMSiteCreation: 'EOM-kohteen luominen',
      workflowTaskUpdateEOMSiteIdPartnerPortal:
        'Päivitä EOM-kohteen tunnus kumppaniportaalissa',
      workflowTaskSyncExistingUsersCBPortal:
        'Synkronoi olemassa olevat käyttäjät CB-portaaliin',
      workflowTaskUpdateUserSyncStatusPartnerPortal:
        'Päivitä käyttäjän synkronointitila kumppaniportaalissa',
      workflowTaskCalculateEnergySavingsPotential:
        'Laske energiansäästöpotentiaali',
      workflowTaskDeleteSiteInCBPortal: 'Poista sivusto CB-portaalissa',
      workflowTaskDeleteSiteInEOM: 'Poista kohde EOM:ssä',
      workflowTaskUpdateSiteInCBPortal: 'Päivitä kohde CB-portaalissa',
      workflowTaskUpdateSiteInEOM: 'Päivitä sivusto EOM:ssa',
      workflowTaskUpdateSiteInAssetModelling:
        'Päivitä kohde omaisuusmallinnuksessa',
      workflowTaskUpdateSiteInFindAPI: 'Päivitä sivusto Find API:ssa',
      workflowTaskSyncSubscriptionAssociationCBPortal:
        'Synkronoi tilauksen liitos CB-portaaliin',
      workflowTaskEnableBrickOntology: 'Ota Brick-ontologia käyttöön',
      workflowTaskOnboardCustomerForgeAPI: 'Ota asiakas käyttöön ForgeAPI:ssa',
      workflowTaskPublishForgeAPIOnboardingStatus:
        'Julkaise ForgeAPI-käyttöönoton tila Credential Managementissa',
      workflowTaskAddUserInCBPortal: 'Lisää käyttäjä CB-portaalissa',
      workflowTaskUpdateUserProvisioningStatus:
        'Päivitä käyttäjän provisioinnin tila',
      workflowTaskDeleteUserInCBPortal: 'Poista käyttäjä CB-portaalista',
      workflowTaskUpdateUserDeletionStatus: 'Päivitä käyttäjän poistotila',
      workflowCustomerCreation: 'Asiakkaan luominen',
      workflowCustomerDelete: 'Asiakkaan poisto',
      workflowCustomerUpdate: 'Asiakkaan päivitys',
      workflowFileAttachmentsScan: 'Tiedostoliitteiden skannaustila',
      workflowSiteCreation: 'Kohteen luominen',
      workflowSiteDelete: 'Kohteen poisto',
      workflowSiteUpdate: 'Kohteen päivitys',
      workflowSubscriptionAssociation: 'Tilauksen liitos',
      workflowAddUser: 'Lisää käyttäjä',
      workflowDeleteUser: 'Poista käyttäjä',
      workflowNamePlate: 'Nimikilpi',
      workflowForgeAPIOnboarding: 'Forge APIn käyttöönotto',
      workflowAddUserMultiple: 'Työnkulku usean käyttäjän lisäämiseksi',
      workflowDeleteUserMultiple: 'Työnkulku usean käyttäjän poistamiseksi',
      workflowModelFileUpload: 'Mallitiedoston lataus',
      workflowGatewayAssociation: 'Yhdyskäytävän liitos',
      workflowIntegrationRegistered: 'Integraatio rekisteröity',
      workflowTaskForgeAPIOnboardingStatus: 'Forgeapi käyttöönoton tila',
      workflowTaskAddUser: 'Työnkulku käyttäjän lisäämiseksi',
      workflowTaskProcessModelFile: 'Prosessin mallitiedosto',
      workflowTaskNotifyAssetModelling: 'Ilmoita omaisuuden mallinnuksesta',
      workflowTaskAssociateGateway: 'Liitä yhdyskäytävä kohteeseen',
      workflowTaskFetchModelToAssetModelling:
        'Hae malli omaisuuden mallinnukseen',
      workflowTaskNameProcessNamePlate: 'Prosessoi nimikilpitiedosto',
      workflowTaskUpdateModelInFindAPI: 'Päivitä malli Find API:ssa',
      workflowTaskProcessIntegrationRegistered:
        'Prosessi-integraatio rekisteröity',
      workflowTaskProcessDFNotificationIntegrationRegistered:
        'Käsittele DF-ilmoitus rekisteröidylle integraatiolle',
      workflowTaskTenantOnboardingAFO:
        'Tenantin käyttöönotto AFO-järjestelmään',
      workflowTaskOnboardCustomerCDL: 'Ota asiakas käyttöön CDL:ää varten',
      workflowTaskPublishAFOOnboardingStatus: 'Julkaise AFO-käyttöönoton tila Rule Builder -palveluun',
      activityLogCorrelationId: 'Korrelaatiotunnus',
      activityLogTaskId: 'Tehtävän tunnus',
      activityLogToastSuccess: 'Onnistui',
      activityLogToastError: 'Virhe',
      activityLogIteration: 'Iterointi',
      activityLogFieldFirstName: 'Etunimi',
      activityLogFieldLastName: 'Sukunimi',
      activityLogFieldSubscriptionName: 'Tilauksen nimi',
      activityLogFieldName: 'Nimi',
      activityLogFieldCurrency: 'Valuutta',
      activityLogFieldZip: 'Postinro',
      activityLogFieldArea: 'Alue',
      activityLogFieldCity: 'Kaupunki',
      activityLogFieldState: 'Tila',
      activityLogFieldCountry: 'Maa',
      activityLogFieldAreaUnit: 'Alueyksikkö',
      activityLogFieldLanguage: 'Kieli',
      activityLogFieldLatitude: 'Leveysaste',
      activityLogFieldSiteType: 'Kohdetyyppi',
      activityLogFieldTimezone: 'Aikavyöhyke',
      activityLogFieldLongitude: 'Pituusaste',
      activityLogFieldCountryCode: 'Maakoodi',
      activityLogFieldSiteId: 'Kohdetunnus',
      activityLogFieldFileType: 'Tiedostotyyppi',
      activityLogFieldReason: 'Syy',
      activityLogFieldCustomerSupportEmails: 'Asiakastuen sähköpostiosoitteet',
      activityLogFieldAddressLine1: 'Osoiterivi 1',
      activityLogFieldAddressLine2: 'Osoiterivi 2',
      activityLogFieldContactEmail: 'Yhteyshenkilön sähköpostiosoite',
      activityLogSiTitle: 'Aktiviteettiloki',
      support: 'Tuki',
      projectManagement: 'Projektinhallinta',
    }
  }
};
